import Heading from 'components/Heading'
import React from 'react'
import { useTranslation } from 'react-i18next'

const FuelSludgeBilgeStep = () => {
  const { t } = useTranslation()

  return (
    <Heading level={3}>
      {t('rob.survey.steps.fuelSludgeBilgeAndComments')}
    </Heading>
  )
}

export default FuelSludgeBilgeStep
